import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Services from "./pages/Services/Services";
import ServiceDetail from "./pages/ServiceDetail/ServiceDetail";
import Projects from "./pages/Projects/Projects";
import ProjectDetail from "./pages/ProjectDetail/ProjectDetail";
import Contact from "./pages/Contact/Contact";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import "./i18n/i18n";

import "./styles/global.css";

function App() {
  return (
    <BrowserRouter>

      {/* Scroll To Top */}
      <ScrollToTop />

      <div className="app-wrapper">
        <Navbar />

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:id" element={<ServiceDetail />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        <Footer />

        {/* Floating Icons */}
        <div className="floating-icons">

  <a
    href="https://wa.me/919950817883"
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-icon"
  >
    <FaWhatsapp />
  </a>

  <a
    href="tel:+919950817883"
    className="call-icon"
  >
    <FaPhoneAlt />
  </a>

</div>
        {/* Fixed Icons */}
        <div className="fixed-icons">
          <a href="tel:+919950817883" className="fixed-icon call-icon" title="Call Us">
            📞
          </a>
          <a href="https://wa.me/919950817883" className="fixed-icon whatsapp-icon" title="Chat on WhatsApp">
            💬
          </a>
        </div>

      </div>
    </BrowserRouter>
  );
}

export default App;